var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9531 23.624H5.39974C5.1694 23.624 4.9485 23.5357 4.78562 23.3784C4.62275 23.2212 4.53125 23.0079 4.53125 22.7855V13.5615C4.53125 12.2401 4.80082 10.9316 5.32457 9.71076C5.84831 8.48992 6.61598 7.38064 7.58374 6.44626C8.5515 5.51187 9.7004 4.77067 10.9648 4.26498C12.2293 3.7593 13.5845 3.49902 14.9531 3.49902H14.9531C16.3217 3.49902 17.677 3.7593 18.9414 4.26499C20.2058 4.77067 21.3547 5.51187 22.3225 6.44626C23.2903 7.38065 24.0579 8.48993 24.5817 9.71077C25.1054 10.9316 25.375 12.2401 25.375 13.5615V13.5615C25.375 16.2303 24.277 18.7897 22.3225 20.6768C20.368 22.5639 17.7172 23.624 14.9531 23.624Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51538 15.3125C10.2661 15.3125 10.8748 14.7249 10.8748 14C10.8748 13.2751 10.2661 12.6875 9.51538 12.6875C8.76462 12.6875 8.15601 13.2751 8.15601 14C8.15601 14.7249 8.76462 15.3125 9.51538 15.3125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.953 15.3125C15.7038 15.3125 16.3124 14.7249 16.3124 14C16.3124 13.2751 15.7038 12.6875 14.953 12.6875C14.2022 12.6875 13.5936 13.2751 13.5936 14C13.5936 14.7249 14.2022 15.3125 14.953 15.3125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3906 15.3125C21.1414 15.3125 21.75 14.7249 21.75 14C21.75 13.2751 21.1414 12.6875 20.3906 12.6875C19.6399 12.6875 19.0312 13.2751 19.0312 14C19.0312 14.7249 19.6399 15.3125 20.3906 15.3125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBtn);
export default __webpack_public_path__ + "static/media/chatBtn.47ff20fcdefc34c414485100902eefa5.svg";
export { ForwardRef as ReactComponent };